<script setup lang="ts">
import AddToDocumentListModal from "@/modules/DocumentLists/components/AddToDocumentListModal.vue";
</script>

<template>
  <RouterView />
  <AddToDocumentListModal />
</template>
